import { filter } from 'lodash'

export const getMemberPreferences = ({ preferences }) => preferences

export const getMember = ({ member }) => member

export const getConsultant = ({ consultant }) => consultant

export const getNotifications = ({ notifications }) => notifications

export const getIntegrations = ({ integrations }) => integrations

export const getUnreadNotifications = ({ notifications }) => filter(notifications, { seen_at: null })

export const isMemberAdmin = ({ member }) => member.is_admin || 0



// WEBPACK FOOTER //
// ./src/modules/profile/store/getters.js